import { Box, Chip, Stack, Typography } from "@mui/material";
import { formatDate } from "../../../../../../infrastructure/utils/formatters";
import { CONTRACT_UX } from "./contractUxTheme";

/**
 * Phase 7.7.4 — Dense dark-blue contract hero.
 */
const ContractHeroCard = ({ ux }) => {
  if (!ux || ux.phase === "empty") return null;

  const dateValue = ux.activatedAt || ux.signedAt || ux.createOn;
  const chipBg =
    ux.phase === "active"
      ? CONTRACT_UX.success
      : ux.phase === "pending_signature" || ux.phase === "awaiting_guarantee"
      ? CONTRACT_UX.warning
      : "rgba(255,255,255,0.2)";

  return (
    <Box
      data-testid="contract-hero-card"
      dir="rtl"
      sx={{
        borderRadius: 2,
        px: CONTRACT_UX.cardPadding,
        py: { xs: 2, md: 2.25 },
        color: "#fff",
        background: `linear-gradient(135deg, ${CONTRACT_UX.primary} 0%, ${CONTRACT_UX.primaryDark} 100%)`,
        boxShadow: "0 8px 24px rgba(0, 91, 143, 0.18)",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "flex-start" }}
        spacing={1.5}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="h6" fontWeight={800} sx={{ mb: 0.75 }}>
            {ux.title}
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            flexWrap="wrap"
            sx={{ rowGap: 0.5, opacity: 0.92 }}
          >
            {ux.contractNumber ? (
              <Typography variant="body2">
                شماره: <strong>{ux.contractNumber}</strong>
              </Typography>
            ) : null}
            <Typography variant="body2">
              تاریخ: <strong>{dateValue ? formatDate(dateValue) : "—"}</strong>
            </Typography>
          </Stack>
          <Typography
            variant="body2"
            sx={{ mt: 1.25, opacity: 0.95, maxWidth: 560 }}
            data-testid="contract-hero-hint"
          >
            {ux.statusHint}
          </Typography>
        </Box>

        <Chip
          label={ux.friendlyStatus}
          data-testid="contract-friendly-status"
          sx={{
            bgcolor: chipBg,
            color: ux.phase === "active" || ux.phase === "pending_signature" || ux.phase === "awaiting_guarantee"
              ? "#fff"
              : "#fff",
            fontWeight: 700,
            height: 32,
            "& .MuiChip-label": { px: 1.5 },
          }}
        />
      </Stack>

      <Box
        data-testid="contract-next-required-action"
        sx={{
          mt: 1.75,
          px: 1.5,
          py: 1,
          borderRadius: 1.5,
          bgcolor: "rgba(255,255,255,0.12)",
          border: "1px solid rgba(255,255,255,0.18)",
        }}
      >
        <Typography variant="caption" sx={{ opacity: 0.85 }} display="block">
          اقدام لازم
        </Typography>
        <Typography variant="subtitle2" fontWeight={800}>
          {ux.nextRequiredAction}
        </Typography>
      </Box>
    </Box>
  );
};

export default ContractHeroCard;
